import { useMutation, useQueryClient } from "@tanstack/react-query";
import { erp } from "@/lib/erp";
import type { PricingRule } from "@/lib/erp";
import { useNavigate } from "react-router-dom";
import { pricingRuleQueryKeys } from "./pricingRuleQueryKeys";
import { buildDetailRoute } from "@/lib/config/docRoutes";

/**
 * Hook for creating a new pricing rule
 * 
 * @returns React Query mutation for creating pricing rule
 */
export function useCreatePricingRule() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation<PricingRule, Error, Record<string, any>>({
    mutationFn: (data: Record<string, any>) => {
      return erp.pricingRules.create(data);
    },
    onSuccess: (data) => {
      const pricingRuleName = data.name;
      
      // Update cache for the new pricing rule
      if (pricingRuleName) {
        queryClient.setQueryData(pricingRuleQueryKeys.detail(pricingRuleName), data);
      }
      
      // Invalidate list queries
      queryClient.invalidateQueries({ queryKey: pricingRuleQueryKeys.list() });
      
      // Redirect to detail page
      if (pricingRuleName) {
        navigate(buildDetailRoute("Pricing Rule", pricingRuleName));
      }
    },
  });
}

